import { useCallback } from "react";
import { useAppDispatch } from "../redux"
import { toggleTraffic as toggleTrafficAction } from "../../store/slices/mapSlice";
import { MapInstance } from "../../types/map";

export const useMapControls = (map: MapInstance | null, isMapReady: boolean) => {
    const dispatch = useAppDispatch();

    const handleTrafficToggle = useCallback(() => {
        if (isMapReady && map) {
            dispatch(toggleTrafficAction());
        }
    }, [dispatch, isMapReady, map]);

    const handleZoomIn = useCallback(() => {
        if (isMapReady && map) {
            try {
                const currentZoom = map.getZoom();
                map.setZoom(Math.min(currentZoom + 1, 18));
            } catch (err) {
                console.warn("Ошибка зума:", err);
            }
        }
    }, [isMapReady, map]);

    const handleZoomOut = useCallback(() => {
        if (isMapReady && map) {
            try {
                const currentZoom = map.getZoom();
                map.setZoom(Math.max(currentZoom - 1, 8));
            } catch (err) {
                console.warn("Ошибка зума:", err);
            }
        }
    }, [isMapReady, map]);

    const toggleTraffic = useCallback((isTrafficVisible: boolean) => {
        if (map && isMapReady) {
            try {
                if (isTrafficVisible) {
                    map.showTraffic();
                } else {
                    map.hideTraffic();
                }
            } catch (err) {
                console.warn("Ошибка переключения трафика:", err);
            }
        }
    }, [map, isMapReady]);

    const updateMapSize = useCallback(() => {
        if (map && isMapReady) {
            setTimeout(() => {
                try {
                    map.invalidateSize();
                } catch (error) {
                    console.warn("Ошибка при обновлении размера карты:", error);
                }
            }, 100);
        }
    }, [map, isMapReady]);

    return {
        handleTrafficToggle,
        handleZoomIn,
        handleZoomOut,
        toggleTraffic,
        updateMapSize,
    };
};